import React from "react";

export default function NotFound() {
  return (
    <section className="h-screen flex justify-center flex-col items-center">
      <h1 className="text-3xl text-gray-900 mt-12 text-center">
        Tunggu sebentar, memuat kelasmu...
      </h1>
    </section>
  );
}
